import DashboardAudioNotificationHelper from 'dashboard/helper/AudioAlerts/DashboardAudioNotificationHelper';
import { isDirectMessageChannel } from './channelDisplay';

const USER_MENTION_REGEX = /mention:\/\/user\/(\d+)\//g;
const ALL_MENTION_REGEX = /(?<![\w])@all\b/;

export function isThreadOnlyInternalChatMessage(data) {
  return (
    Boolean(data?.parent_id) && !data?.content_attributes?.also_send_in_channel
  );
}

export function isUserMentionedInMessage(data, currentUserId) {
  if (!currentUserId) return false;

  const mentionedIds = data?.content_attributes?.mentioned_user_ids || [];
  if (mentionedIds.length) {
    return mentionedIds.map(Number).includes(Number(currentUserId));
  }

  const content = data?.content || '';
  if (ALL_MENTION_REGEX.test(content)) {
    return true;
  }

  USER_MENTION_REGEX.lastIndex = 0;
  let match = USER_MENTION_REGEX.exec(content);
  while (match) {
    if (Number(match[1]) === Number(currentUserId)) {
      return true;
    }
    match = USER_MENTION_REGEX.exec(content);
  }

  return false;
}

export function shouldAlertForInternalChatMessage({
  data,
  channel,
  currentUserId,
  activeChannelId,
}) {
  if (!data || !currentUserId) return false;

  const channelId = data.internal_chat_channel_id;
  if (data.sender?.id === currentUserId) return false;
  if (activeChannelId && activeChannelId === channelId) return false;

  const isMentioned = isUserMentionedInMessage(data, currentUserId);
  if (isMentioned) return true;

  if (!channel) return false;
  if (channel.muted) return false;
  if (
    isThreadOnlyInternalChatMessage(data) &&
    !isDirectMessageChannel(channel)
  ) {
    return false;
  }

  return isDirectMessageChannel(channel);
}

function audioAlertsDisabled() {
  const alertTypes =
    DashboardAudioNotificationHelper.notificationConfig?.audioAlertType || [];
  return alertTypes.includes('none');
}

export function notifyInternalChatMessage({
  data,
  channel,
  currentUserId,
  activeChannelId,
}) {
  if (
    !shouldAlertForInternalChatMessage({
      data,
      channel,
      currentUserId,
      activeChannelId,
    })
  ) {
    return;
  }

  if (audioAlertsDisabled()) return;
  if (!DashboardAudioNotificationHelper.shouldPlayAlert()) return;

  DashboardAudioNotificationHelper.playAudioAlert();
}
